import { useEffect, useState } from 'react';
import { meetlyApi } from '../api/meetly';

/**
 * How many meetings colleagues have shared with the signed-in user. Only asked
 * when `enabled` — for someone WITHOUT Meetly, whose Meeting menu entry exists
 * only to reach "Shared with me". 0 while loading or on any error. A share that
 * arrives later shows up on the next load; its bell notification links straight
 * to the meeting meanwhile.
 */
export function useSharedMeetlyCount(enabled: boolean): number {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return undefined;
    }
    let cancelled = false;
    meetlyApi.listMeetings({ scope: 'shared', page_size: 1 })
      .then(response => { if (!cancelled) setCount(response.data.total || 0); })
      .catch(() => { if (!cancelled) setCount(0); });
    return () => { cancelled = true; };
  }, [enabled]);
  return count;
}
